export enum FloatingMode {
  ON = 'on',
  OFF = 'off',
  AUTO = 'auto'
}

export type FloatingModeKey = FloatingMode | 'on' | 'off' | 'auto';

export interface FloatingElement {
  nativeElement: HTMLElement;
  offset: number;
  stacking: boolean;
  isSmartbar?: boolean;
  isToastMessage?: boolean;
}
